<template>
    <div id="container" type="vhomeserviceslanding">
        <div class="page homeservices-landing" v-ga:request="{pageType:'vhomeserviceslanding', state: {}}" v-ga:page="{pageType:'vhomeserviceslanding', glb: glb, state: {}}">
            <mvtHeader />
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="glb.cdnUrl + 'vimages/homeservices1.webp'" alt="Welcome Home Services Page" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <div class="f7">HOME SERVICE PROVIDERS</div>
                    <h1>
                        <b class="f0 text-bold"> {{ getHeaderText.text1 }} </b>
                    </h1>
                    <p class="f3 lh-normal">
                        <template v-if="glb.homeservices && city && state && glb.homeservices.zipCode">
                            <span>{{ getHeaderText.text2 }}</span> <br /><span class="homeservices-landing__header-location">{{ city }}, {{ state }}</span>
                        </template>
                        <template v-else> <span>Search vetted contractors</span> <br /><span> in your area.</span> </template>
                    </p>
                    <div class="input right input-geo large default">
                        <form v-submit="onSubmit" novalidate>
                            <ThumbtackSearch v-model="search" />
                        </form>
                    </div>
                </template>
            </mvtWelcome>
            <section class="inline large">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <h2 class="f3 text-bold">Popular Searches</h2>
                    <div class="grid fixed xs-grid-cols-1 sm-grid-cols-2 md-grid-cols-4">
                        <div class="flex" v-for="popular in popularSearches">
                            <a :href="getSearchURL(popular)">
                                <picture class="img-bg">
                                    <img  class="corner" loading="lazy" :src="glb.cdnUrl + 'vimages/homeservices/popular/' + popular.image" />
                                </picture>
                                <div class="popular-searches__title f5 text-bold">{{ popular.title }}</div>
                                <div class="popular-searches__subtitle"><i class="icon-map-pin-home"></i> Search pros near you</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section class="inline large">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <h2 class="f3 wrap text-bold">Top Categories</h2>
                    <ul class="grid fixed xs-grid-cols-1 sm-grid-cols-2 md-grid-cols-5">
                        <li v-for="category in topCategories">
                            <a :href="getSearchURL(category)" class="inline flex vertical bg-white corner outline center">
                                <div>
                                    <picture class="flex">
                                        <img class="circle large flex middle" loading="lazy" :src="glb.cdnUrl + 'vimages/homeservices/top/' + category.image" />
                                    </picture>
                                </div>
                                <div class="text-center text-bold multipleline-2">{{ category.title }}</div>
                            </a>
                        </li>
                    </ul>
                </div>
            </section>
            <section>
                <div class="inline welcome gap-3 grid fixed fixed-max-sm middle xs-grid-cols-1 sm-grid-cols-2 corner bg-default">
                    <div>
                        <img class="panel-img object-contain lazyload img-load-success" :src="glb.cdnUrl + 'vimages/homeservices/phone-lockup@2x.png'" loading="lazy"/>
                    </div>
                    <div class="flex vertical large top center">
                        <h3 class="f3 text-bold">Want up-to-date maintenance alerts?</h3>
                        <p>Get tailored recommendations for your home. Stay up-to-date on maintenance to avoid costly repairs.</p>
                        <div>
                            <form autocomplete="off" action="javascript:void(0)">
                                <mvtInputGeo
                                    class="large default"
                                    ref="addressInput"
                                    v-model="geoInfo"
                                    :placeholder="glb.isPhone ? 'Home Address' : 'Enter Your Home Address'"
                                    :options="{types:['address']}"
                                    >Get Started</mvtInputGeo
                                >
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <mvtFooter />
            <mvtPopSignin />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>

<script src="./homeservices-landing.js"></script>
